import { MouseEvent } from 'react';
import { matchPath, useHistory } from 'react-router-dom';

import { getParameterizedLink } from '@/utils/getLinkWithSubscriptionId.utils';
import { SearchBreadcrumbPageNames } from './GridFilteredBySearch.breadcrumb';

interface IGenericFilteredByBreadcrumb {
  defaultText: string;
  breadcrumbPage: SearchBreadcrumbPageNames;
  path: string;
  filteredDisplayName: string;
  filteredSearchParam: string;
}


export default function GenericFilteredBy({
  defaultText,
  breadcrumbPage,
  path,
  filteredDisplayName: filteredByDisplayName,
  filteredSearchParam: filteredParamName
}: IGenericFilteredByBreadcrumb) {
  const history = useHistory();
  const filteredParam = new URL(window.location.href).searchParams.get(filteredParamName) ?? '';
  const onClick = (event: MouseEvent) => {
    event.preventDefault();
    const pathName = new URL(window.location.href).pathname;

    const isContractsFilteredBySavedFilter = matchPath(pathName, {
      path: path,
      exact: true,
    });

    if (isContractsFilteredBySavedFilter) {
      window.location.reload();
    }
    else {
      const link = getParameterizedLink(`${path}?${filteredParamName}=${filteredParam}`);
      history.push(link);
    }
  };


  if (!filteredParam) {
    return <>{defaultText}</>;
  }


  return (
    <a
      onClick={onClick}
      href={window.location.href}
    >
      {`${breadcrumbPage} filtered by ${filteredByDisplayName}: ${filteredParam}`}
    </a>
  );
}
